import { IColumn } from '@fluentui/react';
import { rightAlignHeaderStyle } from 'common/utils/columnUtilities';

export const columns: IColumn[] = [
  {
    key: 'fileReference',
    name: 'File',
    fieldName: 'fileReference',
    minWidth: 90,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: 'indexName',
    name: 'Name',
    fieldName: 'indexName',
    minWidth: 100,
    maxWidth: 160,
    isResizable: true,
  },
  {
    key: '_documentContents',
    name: 'Description',
    fieldName: '_documentContents',
    minWidth: 120,
    maxWidth: 180,
    isResizable: true,
  },
  {
    key: 'indexReferenceNumber',
    name: 'Number',
    fieldName: 'indexReferenceNumber',
    minWidth: 140,
    maxWidth: 220,
    isResizable: true,
  },
  {
    key: 'amount',
    name: 'Amount',
    fieldName: 'amount',
    minWidth: 110,
    maxWidth: 160,
    isResizable: true,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'action',
    name: 'Action',
    fieldName: 'action',
    minWidth: 60,
    maxWidth: 60,
    isResizable: false,
  },
];
